import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserDisplayNameParams {
  userId: string; // server user id
  displayName: string;
}

export class UpdateUserDisplayNameRequest extends Request<IUpdateUserDisplayNameParams, IResult> {
  constructor(params: IUpdateUserDisplayNameParams) {
    super('updateUserDisplayName', params);
  }
}
